import { render, staticRenderFns } from "./BindPhone.vue?vue&type=template&id=14c59de0&scoped=true&"
import script from "./BindPhone.vue?vue&type=script&lang=ts&"
export * from "./BindPhone.vue?vue&type=script&lang=ts&"
import style0 from "./BindPhone.vue?vue&type=style&index=0&id=14c59de0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c59de0",
  null
  
)

export default component.exports